import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PostLoginRedirectService } from '../services/post-login-redirect.service';

/**
 * Remembers where the user was heading, so the login round trip can return
 * them there. The filtering of URLs that are pointless to restore lives in
 * PostLoginRedirectService — this guard used to store `state.url`
 * unconditionally on every `:lang` activation, which meant the intermediate
 * `/es` hop of the login flow overwrote the user's actual deep link.
 */
export const saveRedirectGuard: CanActivateFn = (_route, state) => {
  inject(PostLoginRedirectService).remember(state.url);

  return true;
};
